export default __webpack_public_path__ + "static/media/example3.3a7d4ae8.gif";